import * as React from 'react'

import { useFormContext } from 'react-hook-form'

import { ButtonProps, PrimaryButton } from '@enechain/ecloud-designsystem'

// react-hook-formのFormProviderでwrapされている前提のボタン
export const FormPrimaryButton: React.FC<ButtonProps> = ({
  children,
  ...props
}: ButtonProps): React.ReactElement => {
  const formContext = useFormContext()

  if (formContext == null) {
    throw new Error('FormPrimaryButton must be used within FormProvider')
  }

  const isSubmitting = formContext.formState.isSubmitting
  return (
    <PrimaryButton
      {...props}
      disabled={isSubmitting || props.disabled}
      loading={isSubmitting || props.loading}
    >
      {children}
    </PrimaryButton>
  )
}
